import type { Territory } from '@amzn/vinyl-amzn'
import { globalRef } from '@amazon/vinyl-util'
import { hostTerritory } from '@/territory'

const resolvedRef = globalRef<{ territory?: Territory }>(() => ({}))

export function recordResolvedTerritory(territory: Territory): void {
    resolvedRef.value.territory = territory
}

/**
 * The last territory the marketplace resolved to, else the page host's: for work that must not
 * start the lookup, like a metrics upload after sign-out.
 */
export function resolvedTerritory(): Territory {
    return resolvedRef.value.territory ?? hostTerritory()
}
